<template>
    <div class="icon">
        <svg v-if="icon === 'search'" version="1.1" id="icon-search" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px" viewBox="25 25 20 20" enable-background="new 25 25 20 20"
             xml:space="preserve" class="svg-icon icon-search">
            <path d="M37.201,26.779c3.318,0,6.02,2.701,6.02,6.021c0,3.318-2.701,6.022-6.02,6.022c-3.32,0-6.02-2.704-6.02-6.022
                C31.181,29.48,33.881,26.779,37.201,26.779 M37.201,25.274c-4.157,0-7.526,3.369-7.526,7.525c0,4.156,3.369,7.526,7.526,7.526
                c4.155,0,7.525-3.37,7.525-7.526C44.727,28.643,41.356,25.274,37.201,25.274L37.201,25.274z"/>
            <path d="M32.597,37.404c0.366,0.367,0.366,0.964,0,1.33l-5.765,5.764c-0.367,0.368-0.963,0.368-1.331,0l0,0
                c-0.367-0.367-0.367-0.962,0-1.329l5.765-5.765C31.633,37.037,32.229,37.037,32.597,37.404L32.597,37.404z"/>
        </svg>

        <svg v-if="icon === 'cart'" version="1.1" id="icon-cart" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             width="20px" height="20px" viewBox="0 0 20 20" enable-background="new 0 0 20 20"
             xml:space="preserve" class="svg-icon icon-cart">
            <polygon points="1,2 1,3 2.132,3 5.585,16 18,16 18,15 6.661,15 5.896,12 16.397,12 19.313,4 3.854,4 2.896,2 "/>
            <circle cx="5.415" cy="18.5" r="1.019"/>
            <circle cx="17.058" cy="18.5" r="1.019"/>
        </svg>

        <svg v-if="icon === 'close'" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             width="20px" height="20px" viewBox="0 0 20 20" enable-background="new 0 0 20 20"
             xml:space="preserve" class="svg-icon icon-close">
        <path d="M17.071,2.929c0.391,0.391,0.391,1.023,0,1.415L4.343,17.071c-0.391,0.391-1.024,0.391-1.415,0l0,0
            c-0.39-0.391-0.39-1.024,0-1.414L15.657,2.929C16.048,2.538,16.681,2.539,17.071,2.929L17.071,2.929z"/>
        <path d="M17.071,15.657c0.391,0.391,0.391,1.023,0,1.414l0,0c-0.391,0.391-1.023,0.391-1.414,0L2.929,4.343
            c-0.39-0.391-0.39-1.024,0-1.415l0,0c0.391-0.39,1.024-0.39,1.415,0L17.071,15.657z"/>
        </svg>

        <svg v-if="icon === 'chevron-right'" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             width="20px" height="20px" viewBox="0 0 20 20" enable-background="new 0 0 20 20"
             xml:space="preserve" class="svg-icon icon-chevron-right">
        <path d="M15,10.123c-0.36,0.36-8.292,8.212-8.292,8.212c-0.349,0.349-0.955,0.348-1.305,0l0,0c-0.348-0.349-0.37-0.914-0.021-1.264
            l7.508-7.493L5.363,2.085C5.014,1.736,5.013,1.17,5.362,0.822l0,0c0.349-0.349,0.996-0.349,1.345,0c0,0,7.949,7.867,8.293,8.21
            S15.36,9.763,15,10.123z"/>
        </svg>

        <svg v-if="icon === 'chevron-left'" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             width="20px" height="20px" viewBox="0 0 20 20" enable-background="new 0 0 20 20"
             xml:space="preserve" class="svg-icon icon-chevron-left">
        <path d="M15,10.123c-0.36,0.36-8.292,8.212-8.292,8.212c-0.349,0.349-0.955,0.348-1.305,0l0,0c-0.348-0.349-0.37-0.914-0.021-1.264
            l7.508-7.493L5.363,2.085C5.014,1.736,5.013,1.17,5.362,0.822l0,0c0.349-0.349,0.996-0.349,1.345,0c0,0,7.949,7.867,8.293,8.21
            S15.36,9.763,15,10.123z"/>
        </svg>
    </div>
</template>

<script>
    export default {
        name: 'icons',
        props: ['icon']
    }
</script>

<style lang="scss">
    .icon {
        display: inline-block;
        vertical-align: -2px;
        height: 1em;
        width: 1em;
        fill: #fff;
        stroke: #fff;
    }

    .svg-icon {
        height: inherit;
        width: inherit;
        max-height: 100%;
        max-width: 100%;
        fill: inherit;
        stroke: inherit;
    }

    .icon-chevron-right {
        vertical-align: -0.15vmax;
    }

    .icon-chevron-left {
        vertical-align: -0.15vmax;
        transform: rotate(180deg);
    }
</style>


// WEBPACK FOOTER //
// Icons.vue?2305ea7a